import React from "react";

const TREE_URL = "https://customer-assets.emergentagent.com/job_grief-admin-guide/artifacts/3j0enxq4_Picture1.png";

/**
 * Tree of Life brand mark.
 * The asset is a cream tree on a solid black background. We use
 * `mix-blend-mode: screen` on a dark green tile so black blends into
 * the tile and only the cream tree stays visible.
 *
 * Props:
 *   size: number of pixels (default 40)
 *   tone: 'dark' (dark green tile) | 'light' (bone tile with dark tree via invert)
 */
export default function TreeMark({ size = 40, tone = "dark", className = "" }) {
  const dimension = { width: size, height: size };
  if (tone === "light") {
    return (
      <span
        className={`inline-block rounded-full overflow-hidden bg-[#FAF9F6] border border-[#EAE6E1] ${className}`}
        style={dimension}
        aria-hidden
      >
        <img
          src={TREE_URL}
          alt=""
          className="w-full h-full object-cover"
          style={{ filter: "invert(1) sepia(0.15) saturate(0.7) hue-rotate(50deg) brightness(0.72)" }}
        />
      </span>
    );
  }
  return (
    <span
      className={`inline-block rounded-full overflow-hidden ${className}`}
      style={{ ...dimension, background: "#2D332D" }}
      aria-hidden
    >
      <img
        src={TREE_URL}
        alt=""
        className="w-full h-full object-cover"
        style={{ mixBlendMode: "screen" }}
      />
    </span>
  );
}

export const TREE_ASSET_URL = TREE_URL;
export const TREES_BIRDS_URL = "https://customer-assets.emergentagent.com/job_grief-admin-guide/artifacts/33fgt24s_Picture2.png";
